export default {"src":"/_next/static/media/Dental.39dfcb1b.svg","height":91,"width":91,"blurWidth":0,"blurHeight":0};